<template>
    <div class="col-12 col-lg-4 dashboard__box-col">
        <div class="box" :class="'box--' + contact.color">
            <h2 class="h h--2">{{ contact.name }}</h2>
            <p v-if="contact.title">{{ contact.title }}</p>
            <p v-if="contact.email"><a :href="'mailto: ' + contact.email" class="box__link">{{ contact.email }}</a></p>
            <p v-if="contact.street">{{ contact.street }}</p>
            <p v-if="contact.city">{{ contact.city }}</p>
            <a :href="'tel: ' + contact.phone" class="button button__bottom">
                {{ contact.phone }}
            </a>
        </div>
    </div>
</template>

<script>
export default {
  name: 'ContactBox',
  props: ['contact']
}
</script>


// WEBPACK FOOTER //
// src/app/home/contact/ContactBox.vue